export default __webpack_public_path__ + "static/media/dauRed.26ea4ee9.svg";